export default function fixPoemName(poetID){
  switch(poetID) {
    case 'wood-pile':
      return 'Wood-Pile'
    default:
      let words = poetID.split('-');
      let payload = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
      return payload.join(' ');
  }
}



// WEBPACK FOOTER //
// ./src/helpers/fixPoemName.js